/* eslint-disable */

import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import {
    updateUserSettings
} from 'legacy/containers/ApiUrls';

export const setNSRStatus = (value) => (dispatch, getState) => {
  let promises;
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  const payload = meDataSource.data.profile.settings.map(p =>
    p.key === 'nsr_alert'
      ? { ...p, value}
      : p
  );

  return (
    promises
      .then(() => {
        const apiCalls = [];
        apiCalls.push(dispatch(updateUserSettings(payload)));
        return Promise.all(apiCalls);
        // return Promise.resolve('Success')
      })
      .then(() => dispatch(getMe()))
      .catch(err => {
        // dispatch(updateStatusSosReport(err))
        // console.log('NSR Status Error:', err);
      })
  );
};


// WEBPACK FOOTER //
// ./src/views/state/ProfileSettings/ProfileSettingsActions.js